import { styled } from '@mui/material/styles';
import Typography, {
  typographyClasses,
  TypographyProps,
} from '@mui/material/Typography';

export const RootTypography = styled(Typography)<TypographyProps>(
  ({ theme }) => ({
    [`&.${typographyClasses.root}`]: {
      marginBottom: theme.spacing(2),
      textAlign: 'center',
    },
  }),
);

export const RootTypographyTitle = styled(Typography)<TypographyProps>(
  ({ theme }) => ({
    [`&.${typographyClasses.root}`]: {
      marginBottom: theme.spacing(1),
      textAlign: 'center',
    },
  }),
);
